import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks/useStores';

import { IconButton, Snackbar } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

export const Snackbars = observer(() => {
  const { appStore } = useStores();
  const [open, setOpen] = React.useState(true);
  const message = appStore.snackbarMessages.length
    ? appStore.snackbarMessages[0]
    : undefined;
  React.useEffect(() => {
    if (open !== !!message) setOpen(!!message);
  });
  function handleClose() {
    setOpen(false);
    appStore.snackbarMessages = [...appStore.snackbarMessages.slice(1)];
  }
  return (
    <Snackbar
      open={open}
      message={message}
      autoHideDuration={3000}
      onClose={handleClose}
      action={
        <React.Fragment>
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </React.Fragment>
      }
    />
  );
});
